// extracted by mini-css-extract-plugin
export default {"navFlex":"NavBar_navFlex__v1dbB","logo":"NavBar_logo__AXAcN"};